import React from 'react'
import styled from 'styled-components'
import Statistic from 'antd/lib/statistic'
import { ContentContainer } from './ContentContainer'
import { text } from '../styles/mixins/text'
import { SPACING } from '../styles/mixins/constants'
import { Skeleton } from './Skeleton'
import { Spacer } from './Spacer'

export type YardScoreboardValue = { value: number; label: string }
type Props = {
    className?: string
    isLoading: boolean
    includeStatVehicles: boolean
    values: Array<YardScoreboardValue>
}

export const YardScoreboard = (props: Props): JSX.Element => {
    const { className, values, isLoading, includeStatVehicles } = props
    const stats = values.filter((i) => {
        return i.label !== 'Tractor' || (includeStatVehicles && i.label === 'Tractor')
    })

    if (isLoading)
        return (
            <SkeletonContainer className={className}>
                {Array(6)
                    .fill(null)
                    .map((_, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <Loading key={index}>
                            <Skeleton lineHeight="sub" />
                            <Spacer vertical size={1} />
                            <Skeleton lineHeight="header" />
                        </Loading>
                    ))}
            </SkeletonContainer>
        )

    return (
        <Container className={className}>
            {stats.map(({ value, label }) => (
                <StatContainer key={label}>
                    <Statistic title={label} value={value} />
                </StatContainer>
            ))}
        </Container>
    )
}

const Container = styled(ContentContainer)`
    flex-flow: row wrap;
    flex: 0 0 auto;
    .ant-statistic {
        padding: 0 ${SPACING[4]};
    }
    .ant-statistic-title {
        ${text('label', 'secondary', 'text')}
        white-space: nowrap;
    }
    .ant-statistic-content {
        ${text('title', 'primary', 'text')}
    }
`

const StatContainer = styled.div``

const SkeletonContainer = styled(ContentContainer)`
    min-width: 0;
    min-height: 0;
    display: flex;
    flex: 1 1 auto;
    flex-flow: row nowrap;
    width: 100%;
    padding: ${SPACING[5]};
    grid-column-gap: ${SPACING[2]};
`

const Loading = styled.div`
    display: flex;
    flex: 1 1 auto;
    flex-flow: column nowrap;
`
